.<template>
    <div class="panel-full-culinary panel " v-show="isActive">
        <div class="horizFlex" v-if="showTakeout">
            <optionbuttonstringid ref="ticketTypeOptions" :itemList="ticketTypeList_Culinary" @select="selectTicketTypeCulinary" :initialSelectedId="ticketType_Culinary" :disabled="disableCulinaryOptions"/>
   
        </div>
        
        <div>
            <!-- dine in -->
            <div v-if="dineInSelected" class="horizFlex leftjustified">

                

                <div class="vertFlex centered " v-if="IsAdmin">
                      <label class="">Server</label>  
                     
                      <div class="serverdiv">
                          <optionbutton ref="employeeOptions" :itemList="employeeList_Culinary" @select="selectEmployeeCulinary_FromOptions" :useSmallButtons="paramTrue" :initialSelectedId="employee_Culinary.id" :disabled="disableCulinaryOptions"/>
                      </div>
                      
                  </div>
                   
                  <tableadmin ref="tableadmin" @selecttable="selecttablefrommap" v-if="showTableMap" :disabled="disableCulinaryOptions" :inSelectedTableNumber="tableNumber_Culinary"/>
                  <label class="" v-if="!showTableMap">Table</label>
                  <div class="horizFlex" v-if="!showTableMap">
                      <optionbutton ref="tableOptions" :itemList="tableList_Culinary" @select="selectTable" :useNarrowButtons="paramTrue" :initialSelectedId="tableNumber_Culinary" :disabled="disableCulinaryOptions"/>
                  </div>
             
              


            </div>

            <!-- takeout -->
            <div v-if="takeoutSelected" class="innerpanelculinary">
                <div class="horizFlex guestentry">
                    
                    <label class="guestlabel ">Guest Name</label>
                    <input class="takeoutinput capital" v-model="guestName_Culinary" @input="changeGuestName" @keyup.enter="AddTicket_Culinary(false)" :disabled="disableCulinaryOptions"/>
                    <button class="btn-tocart " @click="AddTicket_Culinary(false)" v-show="isValid && takeoutSelected && ticket.id==0">Continue to Cart</button>
                </div>
                
            </div>
        </div>
        

        <div v-if="pleaseWait">
          <label class="pleasewait" for>Please Wait...</label>
        </div>

        <div>

        </div>
  
      <div class="nextbutton" v-if="isNewTicket || isReservationTicket">
        <button class="btn" @click="AddTicket_Culinary(true)" v-show="isValid && dineInSelected && showSeatGuests">Seat Guests</button>
        <button class="btn" @click="AddTicket_Culinary(false)" v-show="isValid && dineInSelected">Continue to Cart</button>
      </div>

      <div class="nextbutton" v-if="!isNewTicket && !isReservationTicket">
        <button class="btn" @click="inEdit=true" v-show="!inEdit">Update</button>
        <button class="btn" @click="save()" v-show="inEdit">Save</button>
        <button class="btn" @click="inEdit=false" v-show="inEdit">Cancel</button>

      </div>

    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import format from '../../style/format.js'
  import dataModel from '../../store/dataModel'
  import linkbutton from '../controls/linkbutton.vue'
  import optionbutton from '../controls/optionbutton.vue'
  import optionbuttonstringid from '../controls/optionbuttonstringid.vue'
  import entry from '../controls/entry.vue'
  import pos from '../../services/pos.js'
  import pos_culinary from '../../services/pos_culinary.js'
  import tableadmin from './tableadmin.vue'
import Tableadmin from './tableadmin.vue'
  export default {
    components:{
        linkbutton,
        optionbutton,
        entry,
        optionbuttonstringid,
        tableadmin
    },
    data() {
      return {
        
        paramTrue:true,
        param1:1,
        inEdit:false
        

      };
    },
    mixins:[dataModel,format,pos, pos_culinary],
    props: ["panelIndex"],
    computed: {
      ...mapFields([
              'panels',
              
          ]),
          
      isActive: function() {
        return this.panels[this.panelIndex].active;
      },
      isValid: function() {
        return this.panels[this.panelIndex].valid;
      },
      priorValid: function() {
        return this.panels[this.panelIndex - 1].valid;
      },
      dineInSelected(){
        return this.ticketType_Culinary=='Dine In'
      },
      takeoutSelected(){
        return this.ticketType_Culinary=='Take Out'
      },
      isNewTicket(){
        return this.ticket.id==0
      },
      isReservationTicket(){
        return this.ticket.id>0 && this.ticket.seatingId>0 && this.ticket.employeeId==0
      },
      disableCulinaryOptions(){
        if(this.isReservationTicket){
          return false
        }
        else if(this.ticket.id>0 && !this.inEdit){
          return true
        }else{
          return false
        }
      }
    },
    watch:{
      isActive:function(val){
        if(this.isActive){this.show()}
      }
    },
    methods: {
      selecttablefrommap(table){

        console.log('sel ' + table.tableNumber)
        if(this.inEdit){
          this.tableNumber_Culinary=table.tableNumber

        }
        else{
          this.selectTable(table.id, table.tableNumber)
        }
        
      },
      selectEmployeeCulinary_FromOptions(id,name){
        if(this.inEdit){
          this.employee_Culinary={
              id:id,
              name:name
            }
        }else{
          this.selectEmployeeCulinary(id,name)
        }
      },
     show(){
        this.GetPrepAreas()
        
        this.getEmployeeList_Culinary()

        this.$nextTick(() => {
          if(this.showTableMap){
            this.$refs.tableadmin.getTables()
            this.$refs.tableadmin.getTableTickets()
            
           
          
          }
          
        })
      },
     
     
     
     
        
        
        isSelected(g){
          return g.id==this.guest.id
        },
 
        
      toNext: function() {

        var nextPanelIndex = Number(this.panelIndex) + 1;
        this.$store.dispatch('setActivePanel',nextPanelIndex); 
      },
      save(){
        //save stuff
        this.selectTable(0, this.tableNumber_Culinary)
        //this.AddTicket_Culinary(false,true)
        this.inEdit=false
      }
     
    },
    mounted(){
        this.show()
    }
  };
  </script>
  
  <style scoped>
  .guestfull {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 80px auto 80px;
    grid-template-areas:
      "lookup"
      "details"
      "next";
  }
  .toggle{
    background-color: blue;
  }
  .togglehighlight{
    background-color: yellow;
  }
.innerpanelculinary{
    margin:40px;
}
.marginbottom{
    margin-bottom:30px;
}
.margintop{
    margin-top:20px;
}
.guestlabel{
    margin-right:20px;
}
.guestentry{
    width:500px;
}
.serverdiv{
  max-width:250px;
  /* max-height:150px; */
  overflow-y: auto;
  overflow-x:hidden;
}
.capital{
  text-transform: capitalize;
}
.takeoutinput{
  height:20px;
  margin:0px;
}
.btn-tocart {
  background-color: var(--button-color);
  color: var(--light-text-color);
  margin: 0px 0px 0px 10px;
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-smaller);
}
  </style>